import type { SSRContext } from '@/types/ssr/SSRContext.ts'
import { type SupportedLocale, supportedLocales } from '@/config/supportedLocales.ts'

export const determineLocale = (ssrContext?: SSRContext): SupportedLocale => {
  const hostname = ssrContext ? ssrContext.hostname : window.location.hostname

  if (!import.meta.env.SSR) {
    const stored = localStorage.getItem('preferredLocale')

    if (supportedLocales.includes(stored as SupportedLocale)) {
      return stored as SupportedLocale
    }
  }

  const tld = hostname.split('.').pop()
  if (tld === 'nl') {
    return 'nl'
  }

  if (tld === 'com') {
    return 'en'
  }

  return 'en'
}
